import './Vendor'
import './styles/bootstrap.scss'
import './styles/app.scss'
import './styles/themes/theme-0.scss'

import React, { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Routes from './Routes'
import MaintenanceScreen from './components/Maintenance'
import { inject } from 'mobx-react'
import GlobalStyle from './styles/global'
import { ThemeProvider } from 'styled-components'
import { light } from './styles/patterns'
import { ToastContainer } from 'react-toastify'
import SnackbarProvider from 'react-simple-snackbar'
import 'react-toastify/dist/ReactToastify.min.css'
import 'antd/dist/antd.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider, ErrorBoundary } from '@rollbar/react'
const queryClient = new QueryClient()

function getRollbarCrashContext(error, info) {
  const authStore = window._____APP_STATE_____?.authStore
  const crashContext = {
    selectedTenant: authStore?.selectedTenant,
    currentUserId: authStore?.currentUserId,
    email: authStore?.email,
    componentStack: info?.componentStack,
    errorMessage: error?.message,
  }

  // eslint-disable-next-line no-console
  console.log(authStore?.selectedTenant)
  // eslint-disable-next-line no-console
  console.log(authStore?.email)

  return {
    crashContext,
  }
}

function RollbarTestCrashButton() {
  const [shouldCrash, setShouldCrash] = useState(false)

  if (shouldCrash) {
    throw new Error('Rollbar test exception: triggered manually from the test button.')
  }

  return (
    <button
      type="button"
      onClick={() => setShouldCrash(true)}
      style={{
        position: 'fixed',
        right: '16px',
        bottom: '16px',
        zIndex: 9999,
        border: 'none',
        borderRadius: '999px',
        padding: '10px 14px',
        background: '#b91c1c',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
      }}
    >
      Test Rollbar Crash
    </button>
  )
}

function App(props) {
  useEffect(
    () => {
      if (!props.rootStore.authStore.initialized) props.rootStore.authStore.initialize()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  const rollbarConfig = {
    accessToken: 'f4ae5899c54e45c1b52824585a825366',
    environment: 'testenv',
  }
  const showRollbarTestButton = rollbarConfig.environment === 'testenv'

  return (
    <>
      <Provider config={rollbarConfig}>
        <ErrorBoundary extra={getRollbarCrashContext}>
          <ThemeProvider theme={light}>
            <SnackbarProvider>
              <QueryClientProvider client={queryClient} contextSharing={true}>
                <BrowserRouter>
                  <Routes />
                </BrowserRouter>
              </QueryClientProvider>
            </SnackbarProvider>
            <MaintenanceScreen />
            <GlobalStyle />
            <ToastContainer newestOnTop closeButton={false} hideProgressBar position="top-left" />
          </ThemeProvider>
        </ErrorBoundary>
      </Provider>
    </>
  )
}
export default inject('rootStore')(App)
